import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

import Authenticator from '@/auth/Authenticator'
import store from '@/store'

let auth = new Authenticator()

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'Home' || to.name === 'Auth' || store.state.auth.authenticated) { return next() }

  return auth.login()
})

export default router
